import request from '@aned/request';
import { removeApiPrefix } from '@/utils/requestPath';

// 区域到区域标准时效 - 分页查询
export const areaToAreaStandardPageApi = '/api/cityToCity/dispatchRegionToRegion/selectPage';
// 区域到区域标准时效 - 导出
export const areaToAreaStandardExportApi = '/api/cityToCity/dispatchRegionToRegion/export';

export const areaToAreaStandardPagePath = removeApiPrefix(areaToAreaStandardPageApi);
export const areaToAreaStandardExportPath = removeApiPrefix(areaToAreaStandardExportApi);

// 区域到区域标准时效 - 分页查询
export async function fetchAreaToAreaStandardPage(params) {
  return request(areaToAreaStandardPageApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 区域到区域标准时效 - 导出
export async function fetchAreaToAreaStandardExport(params) {
  return request(areaToAreaStandardExportApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
